import { Button } from '@codegouvfr/react-dsfr/Button';
import { useTextes } from '@common/config';
import { StateSetter } from '@common/services';
import { RncpAjoutDto } from '@common/services/rncp';
import { DsfrModal } from '@common/ui';
import { swapItems } from '@common/utils/array';
import { closestCenter, DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import type { DragEndEvent } from '@dnd-kit/core/dist/types';
import { restrictToFirstScrollableAncestor, restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import React from 'react';
import { RncpItem } from '../components/RncpItem';

export const RncpSelectionModal = ({
                                     dsfrModal,
                                     selectedRncps,
                                     setSelectedRncps,
                                     onDelete,
                                   }: RncpSelectionModalProps) => {
  const t = useTextes('ParcoursOfa', 'EtapierStep3');

  const sensors = useSensors(
    useSensor(PointerSensor),
  );

  const orderUp = (index: number) => {
    if (index === 0) return;

    const copy = [...selectedRncps];
    swapItems(copy, index, index - 1);
    setSelectedRncps(copy);
  };

  const orderDown = (index: number) => {
    if (index === selectedRncps.length - 1) return;

    const copy = [...selectedRncps];
    swapItems(copy, index, index + 1);
    setSelectedRncps(copy);
  };

  const onDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      setSelectedRncps((array) => arrayMove(
        array,
        array.findIndex(({ id }) => id === active.id),
        array.findIndex(({ id }) => id === over.id),
      ));
    }
  };

  return (
    <dsfrModal.Component title=""
                         size="large"
                         topAnchor={false}
                         buttons={[
                           {
                             children: 'FERMER',
                             doClosesModal: true,
                             priority: 'primary',
                           },
                         ]}>

      <div className={'flex flex-col gap-4 px-6'}>
        <h4 className={'m-0!'}>{t['RNCP_POP_TEXT1']}</h4>

        <DndContext sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragEnd={onDragEnd}
                    modifiers={[restrictToVerticalAxis, restrictToFirstScrollableAncestor]}>

          <SortableContext items={selectedRncps} strategy={verticalListSortingStrategy}>

            {(selectedRncps.map((rncp, index) => (
              <div key={index + rncp.id + rncp.rncp} className={'flex gap-2'}>

                <div className={'flex flex-col justify-between py-2'}>

                  <Button iconId="fr-icon-arrow-up-fill"
                          priority="tertiary"
                          disabled={index === 0}
                          onClick={() => orderUp(index)}
                  />

                  <Button iconId="fr-icon-arrow-down-fill"
                          priority="tertiary"
                          disabled={index === selectedRncps.length - 1}
                          onClick={() => orderDown(index)}
                  />
                </div>

                <div className={'flex-1'}>
                  <RncpItem rncp={rncp}
                            order={index + 1}
                            onDelete={() => onDelete(rncp.id)} />
                </div>
              </div>
            )))}
          </SortableContext>
        </DndContext>
      </div>
    </dsfrModal.Component>
  );
};

interface RncpSelectionModalProps {
  dsfrModal: DsfrModal;
  selectedRncps: RncpAjoutDto[];
  setSelectedRncps: StateSetter<RncpAjoutDto[]>;
  onDelete: (id: number) => void;
}
